import {
  Flex,
  HintIcon,
  Space,
  Text,
  type TextColor,
  type TextVariant,
  type TextWeight,
} from '@/components';
import { FALLBACK_TEXT } from '@/utils';
import type { SpaceProps } from 'antd';
import {
  type CSSProperties,
  type FC,
  type ReactNode,
  isValidElement,
} from 'react';

type Props = {
  label: string;
  labelVariant?: TextVariant;
  labelWeight?: TextWeight;
  labelColor?: TextColor;
  text: ReactNode;
  variant?: TextVariant;
  weight?: TextWeight;
  color?: TextColor;
  fallbackText?: string;
  textAlign?: 'left' | 'right';
  direction?: SpaceProps['direction'];
  align?: SpaceProps['align'];
  hint?: string;
  wrapperStyle?: CSSProperties;
  restrictWrap?: boolean;
};

export const LabeledText: FC<Props> = ({
  label,
  labelVariant = 'h5',
  labelWeight = 'bold',
  labelColor = 'normal',
  text,
  variant = 'body',
  weight = 'medium',
  color = 'normal',
  textAlign = 'left',
  fallbackText = FALLBACK_TEXT,
  direction = 'vertical',
  align,
  hint,
  wrapperStyle,
  restrictWrap,
}) => {
  return (
    <Space
      size="small"
      direction={direction}
      align={align}
      style={{ width: '100%', ...wrapperStyle }}
    >
      <Flex gap={4} align="center" data-dd-privacy="allow">
        <Text
          variant={labelVariant}
          weight={labelWeight}
          color={labelColor}
          text={label}
          style={restrictWrap ? { whiteSpace: 'nowrap' } : undefined}
        />
        {hint && <HintIcon hint={hint} />}
      </Flex>
      <Flex justify={textAlign === 'right' ? 'flex-end' : 'flex-start'}>
        {isValidElement(text) ? (
          <>{text}</>
        ) : (
          <Text
            variant={variant}
            weight={weight}
            color={color}
            text={text as string | number}
            fallbackText={fallbackText}
            style={restrictWrap ? { whiteSpace: 'nowrap' } : undefined}
          />
        )}
      </Flex>
    </Space>
  );
};
